/** temp fix for react 18 implicit children errors. Remove when we upgrade to react 18
 * https://www.notion.so/captivateiq/React-18-migration-Implicit-children-error-tracker-49206d4ebf084ba2ba0924e60db3fc33
 */
import { PopoverTrigger as OrigPopoverTrigger } from '@chakra-ui/react';

export const PopoverTrigger: React.FC<{ children: React.ReactNode }> = OrigPopoverTrigger;
/** temp end */

// keep these alphabetized
export * from '@chakra-ui/react';
export { ChakraWrapper } from './ChakraWrapper';
// TODO: refactor these exports more cleanly
export { CommandBar, CommandBarProvider } from './CommandBar/CommandBar';
export { CommandBarButton } from './CommandBar/CommandBarButton';
export type { CommandBarBaseAction, CommandBarCustomHeaderIconMap } from './CommandBar/types';
export { QuotientAlert as Alert } from './theme/components/Alert/Alert';
export { QuotientAvatar as Avatar } from './theme/components/Avatar/Avatar';
export { QuotientBadge as Badge } from './theme/components/Badge/Badge';
export { Button } from './theme/components/Buttons/Button';
export { QuotientCheckbox as Checkbox } from './theme/components/Checkbox/Checkbox';
export { QuotientCheckboxGroupField as CheckboxGroupField } from './theme/components/CheckboxGroupField/CheckboxGroupField';
export { QuotientCloseButton as CloseButton } from './theme/components/CloseButton/CloseButton';
export { QuotientDrawerCloseButton as DrawerCloseButton } from './theme/components/CloseButton/DrawerCloseButton';
export { Field } from './theme/components/Field';
export { QuotientIcon as Icon } from './theme/components/Icon/Icon';
export { QuotientCombobox as Combobox } from './theme/components/Combobox/Combobox';
export { QuotientIconButton as IconButton } from './theme/components/IconButton/IconButton';
export { QuotientIllustration as Illustration } from './theme/components/Illustration/Illustration';
export { QuotientInput as Input } from './theme/components/Input/Input';
export { QuotientInputGroupField as InputGroupField } from './theme/components/InputGroupField/InputGroupField';
export { QuotientModalCloseButton as ModalCloseButton } from './theme/components/CloseButton/ModalCloseButton';
export { QuotientRadioGroup as RadioGroup } from './theme/components/Radio/Radio';
export { QuotientRadioGroupField as RadioGroupField } from './theme/components/RadioGroupField/RadioGroupField';
export { QuotientSearch as Search } from './theme/components/Search/Search';
export { QuotientSelect as Select } from './theme/components/Select/Select';
export { QuotientSelectGroupField as SelectGroupField } from './theme/components/SelectGroupField/SelectGroupField';
export { QuotientSwitch as Switch } from './theme/components/Switch/Switch';
export { QuotientSwitchGroupField as SwitchGroupField } from './theme/components/SwitchGroupField/SwitchGroupField';
export { QuotientTooltip as Tooltip } from './theme/components/Tooltip/Tooltip';
export { QuotientTag as Tag } from './theme/components/Tag/Tag';
export { FilterDrawer } from './FilterDrawer/FilterDrawer';
export { FilterSection } from './FilterDrawer/FilterSection';
export { ThreadContainer } from './ThreadContainer/ThreadContainer';
export { useQuotientToast as useToast } from './theme/components/Toast/useToast';
export { MotionBox } from './utils/MotionBox';
export { StatsCard } from './StatsCard/StatsCard';
export { DeleteModalFooterWithConfirmation } from './theme/components/Modal/DeleteModalFooterWithConfirmation';
export { PaginatedModal } from './theme/components/Modal/PaginatedModal';
export { Navigator } from './Navigator/Navigator';
export { NavigatorSidebar } from './Navigator/NavigatorSidebar';
export { MultiNavigationPanel } from './MultiNavigationPanel/MultiNavigationPanel';
export { i18n } from './i18n';
export { quotientTheme as theme } from '@captivateiq/quotient';
